export const theme = {
  colors: {
    primary: "#e6be03",
  },
};
